import { EventEmitter } from '@angular/core';
import { JPEG_CONTENT_TYPE, PDF_CONTENT_TYPE, PNG_CONTENT_TYPE } from 'NewAngular/constants/data-upload.constants';
import { LPLIntegrationService } from 'IntegrationsApp/ts/services/lpl-integration.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { StaticFileUrlService } from 'NewAngular/services/static-file-url.service';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/lpl-integration.service";
import * as i2 from "NewAngular/services/static-file-url.service";
import * as i3 from "NewAngular/services/core/urls.service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i8 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i9 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "../../../../../../../../../../../ycharts/static/ts/features/components/file-upload/multiline-file-upload/multiline-file-upload.component";
function LPLActivateModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 6);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Sending email...");
} }
function LPLActivateModalComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r0.errorMessage);
} }
function LPLActivateModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵtemplate(3, LPLActivateModalComponent_div_4_div_3_Template, 1, 1, "div", 10);
    i0.ɵɵelementStart(4, "div", 11)(5, "b");
    i0.ɵɵtext(6, "To connect your LPL integration to YCharts, please complete the following steps:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵtext(8, " 1. Fill out LPL Form F688 to give permission to connect the integration. This PDF form can be downloaded below. If you have any questions, please reach out to your support contact. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 11)(10, "a", 12);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 13);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(12, "span");
    i0.ɵɵtext(13, "Download Form");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(14, "div", 11);
    i0.ɵɵtext(15, " 2. Upload Form F688 below. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 11);
    i0.ɵɵtext(17, " Once the form has been uploaded, our team will send this form to LPL on your behalf to process. Once the data has been added to your account, your integration will be activated, and you will be able to begin importing data directly within the portfolios page. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 11);
    i0.ɵɵelement(19, "ycn-multiline-file-upload", 14);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.errorMessage !== "");
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("href", ctx_r0.lplFormFullStaticLocation, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-download");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("uploadUrl", ctx_r0.lplFormUploadUrl)("uploadFieldName", ctx_r0.uploadFieldName)("validFileTypesType", ctx_r0.validFileTypesType)("successfulUploadConfirmMessage", " Your file is in the correct format and has been successfully submitted.");
} }
export class LPLActivateModalComponent {
    constructor(lplIntegrationService, staticFileUrlService, urlsService) {
        this.lplIntegrationService = lplIntegrationService;
        this.staticFileUrlService = staticFileUrlService;
        this.urlsService = urlsService;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.errorMessage = '';
        this.loading = false;
        this.uploadFieldName = 'form';
        this.lplFormLocation = 'accounts/docs/RE-F688-0525.pdf';
        this.lplFormFullStaticLocation = '';
        this.validFileTypesType = [PDF_CONTENT_TYPE, PNG_CONTENT_TYPE, JPEG_CONTENT_TYPE];
        this.lplFormUploadUrl = '';
        this.modalOpen = false;
        this.lplFormUploadUrl = this.urlsService.ACCOUNTS.INTEGRATIONS_LPL_FORM_UPLOAD;
    }
    ngOnInit() {
        this.staticFileUrlService.getAbsoluteURL(this.lplFormLocation).subscribe((url) => {
            this.lplFormFullStaticLocation = url;
        });
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.closeModalHandler.emit();
    }
    onSubmit() {
        this.lplIntegrationService.activateLPLIntegration().subscribe({
            next: () => {
                this.closeModal();
                window.location.reload();
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage = err.error.errorMessage;
            },
        });
    }
}
LPLActivateModalComponent.ɵfac = function LPLActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || LPLActivateModalComponent)(i0.ɵɵdirectiveInject(i1.LPLIntegrationService), i0.ɵɵdirectiveInject(i2.StaticFileUrlService), i0.ɵɵdirectiveInject(i3.UrlsService)); };
LPLActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: LPLActivateModalComponent, selectors: [["ycn-lpl-integration-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, decls: 6, vars: 8, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "cancelButtonText", "showSubmitButton"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], ["target", "_blank", "download", "", 1, "btn", "btn-link", 3, "href"], ["ycnIcon", "", 3, "name"], [3, "uploadUrl", "uploadFieldName", "validFileTypesType", "successfulUploadConfirmMessage"], [1, "form-row", "text-red", 3, "textContent"]], template: function LPLActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function LPLActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function LPLActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, LPLActivateModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 3)(4, LPLActivateModalComponent_div_4_Template, 20, 7, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 5);
        i0.ɵɵlistener("cancelHandler", function LPLActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function LPLActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate LPL Integration");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Activate")("cancelButtonText", "Close")("showSubmitButton", false);
    } }, dependencies: [i4.NgIf, i5.IconDirective, i6.LoadingSymbolComponent, i7.ModalBaseComponent, i8.SimpleModalFooterComponent, i9.SimpleModalHeaderComponent, i10.MultilineFileUploadComponent], encapsulation: 2 });
